export default __webpack_public_path__ + "7a768757bbd53b1234d3ba193db0df1a.svg";